import React from 'react';
import { useSelector } from 'react-redux';

import { headerAndFooter as config } from '@config';
import EditorFacade from 'assets/js/editor/facade/editor/editor';
import HeaderAndFooter from 'src/components/HeaderAndFooter/HeaderAndFooter';
import { isEven } from 'src/utils/numbers';
import ReactAppBuilder from 'src/utils/react-app-builder';

class HeaderAndFooterApp extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp () {
    super.mountApp(this.App);
  }

  handleHeaderClick () {
    EditorFacade.handle('header_and_footer', 'open', {
      type: 'headerView'
    });
  }

  handleFooterClick () {
    EditorFacade.handle('header_and_footer', 'open', {
      type: 'footerView'
    });
  }

  getTranslations (key) {
    const { oddAndEven, range } = INKIVE.EditorFacade.get('header_and_footer', 'range');
    const keys = {
      key: `popupmenu.header_and_footer.label.${key}`,
      odd: `popupmenu.header_and_footer.label.odd_${key}`,
      even: `popupmenu.header_and_footer.label.even_${key}`,
      allPages: 'popupmenu.header_and_footer.label.all_pages'
    };
    const oddEvenKey = isEven(INKIVE.Tool._current_page_number) ? 'even' : 'odd';
    const description = range === 'all' ? INKIVE.TranslateHelper.translate(keys.allPages) : `Pages ${range}`;

    return {
      label: INKIVE.TranslateHelper.translate(oddAndEven ? keys[oddEvenKey] : keys.key),
      description: range ? description : undefined
    };
  }

  mapProps = ({ header, footer } = {}) => {
    const zoom = useSelector(state => state.editor.zoom);
    const headerSize = useSelector(state => state.editor.header.size?.value);
    const footerSize = useSelector(state => state.editor.footer.size?.value);
    const canvasRelativeSize = useSelector(state => state.editor.canvasRelativeSize);
    const currentLayer = useSelector(state => state.editor.currentLayer);
    const headerHeight = (headerSize / 100 * canvasRelativeSize.height) || header.height;
    const footerHeight = (footerSize / 100 * canvasRelativeSize.height) || footer.height;

    return {
      header: {
        ...this.getTranslations('header'),
        x: canvasRelativeSize.x * zoom,
        y: (canvasRelativeSize.y + headerHeight) * zoom,
        width: header.width * zoom,
        height: headerHeight * zoom,
        isActive: [config.header.layer].includes(currentLayer),
        onClick: this.handleHeaderClick
      },
      footer: {
        ...this.getTranslations('footer'),
        x: canvasRelativeSize.x * zoom,
        y: (canvasRelativeSize.y + footer.y) * zoom,
        width: footer.width * zoom,
        height: footerHeight * zoom,
        isActive: [config.footer.layer].includes(currentLayer),
        onClick: this.handleFooterClick
      }
    };
  };

  App = () => {
    const props = this.mapProps(
      EditorFacade.handle('header_and_footer', 'get_size')
    );

    return <HeaderAndFooter {...props} />;
  };
}

export default new HeaderAndFooterApp({
  appId: 'layout-header-and-footer',
  targetNodeSelector: '#workarea'
});
